<template>
    <div class="tooltip-container slideUp" :class="[customClass, type, $mq, { recommendation: recommendationMode }]">
        <div class="andy-mood slideRight"></div>
        <div
            class="andy-talk"
            :class="type"
            v-on="talkListeners"
        >
            <template v-if="recommendationMode">
                <i class="i-andy-info-main i-andy-s recommendation-info" aria-hidden="true"></i>
                <span class="preview hide-scrollbar recommendation-message" v-html="recommendationMessage"></span>
                <div class="recommendation-actions">
                    <button type="button" class="recommendation-btn recommendation-btn--ghost" @click.stop="$emit('secondary')">
                        {{ secondaryButton }}
                    </button>
                    <button type="button" class="recommendation-btn recommendation-btn--primary" @click.stop="$emit('primary')">
                        {{ primaryButton }}
                    </button>
                </div>
            </template>
            <template v-else>
                <span v-if="html" class="preview hide-scrollbar" v-html="message"></span>
                <vue-typed-js v-else :strings="[message]" :loop="false" :typeSpeed="2" :startDelay="0" :showCursor="false">
                    <span class="preview hide-scrollbar typing"></span>
                </vue-typed-js>
                <div v-if="actionType == ''" class="close fadeInFast"></div>
                <div v-else class="button-undo">{{ textButton }}</div>
            </template>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VueTypedJs from 'vue-typed-js'
Vue.use(VueTypedJs)

export default {
    props: {
        /**
         * BUILD-7486: layout persistente con 2 botones.
         * false = snackbar clásico (crear timers, errores, undo).
         */
        recommendationMode: {
            type: Boolean,
            default: false
        },
        recommendationMessage: {
            type: String,
            default: ''
        },
        primaryButton: {
            type: String,
            default: ''
        },
        secondaryButton: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false,
            talk: false,
            closeable: true,
            type: '',
            duration: 3000,
            message: '',
            action: function () {},
            customClass: '',
            actionType: '',
            textButton: '',
            html: false
        }
    },
    computed: {
        talkListeners() {
            if (this.recommendationMode) {
                return {}
            }

            return { click: this.onTalkClick }
        }
    },
    methods: {
        actionTooltip() {
            this.action(this)
        },
        onTalkClick(event) {
            if (this.recommendationMode) {
                return
            }

            this.actionTooltip()
        }
    },
    created() {
        // playSound('empty.wav')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.tooltip-container {
    @include interaction();
    @include display-flex();
    @include flex-wrap();
    @include justify-content();
    @include align-items(center);
    width: 100%;
    height: auto;
    position: fixed;
    left: 0;
    bottom: 10px;
    z-index: $z-snackbar-default;
    pointer-events: none;

    .andy-mood {
        @include background($image: img('alex_carita_02_right.svg'), $size: contain);
        width: 60px;
        height: 60px;
        display: inline-block;
        margin-right: 6px;
        pointer-events: initial;
    }


    @media (min-width: 901px) {
        .snackbar-label{
            margin-right: calc(((30% - 0.275rem) / 2))
        }
    }
    

    .andy-talk {
        @include background($color: $inactive-t90, $size: 30px);
        @include default-box-shadow();
        @include border-radius(4px);
        @include align-items();
        @include font-size(ml);
        @include flex-direction(row);
        color: $inactive-s70;
        font-family: $conden;
        min-width: $menu-top-height;
        max-width: calc(100% - 120px);
        width: auto;
        min-height: 40px;
        height: auto;
        padding: 10px 12px;
        pointer-events: initial;
        @include display-flex();
        box-shadow: none;

        span {
            text-align: left;
            font-family: $text-light;
            @include font-size(sm);
        }

        & b,
        & a {
            font-family: $text-bold;
            @include font-size(sm);
        }

        & a {
            text-decoration: underline;
        }
    }

    .typed-element {
        width: calc(100% - 40px);
        padding-right: 25px;
    }

    .close {
        width: 40px;
        height: 40px;
        @include background($image: img('tick_ffffff.svg'), $size: 25px);
        display: flex;
        @include border-radius(4px);

        &:hover {
            opacity: 0.5;
        }
    }

    &.info {
        &.new-desing{
            .typed-element{
                width: 100%;
                padding-right: 0;
            }
            .andy-talk {
                background-color: $color-info-500;
                span{
                    color: $color-white;
                }
            }
            .close{
                display: none;
            }
        }
        .andy-mood {
            background-image: img('alex_carita_10.svg');
        }
        .andy-talk {
            background-color: $info-t30;
            color: $info-s70;
        }
        .close {
            background-color: $info-s20;
        }
    }
    &.success {
        .andy-mood {
            background-image: img('alex_carita_07.svg');
        }
        .andy-talk {
            display: flex;
            align-items: center;
            gap: 16px;
            flex: 0 1 auto;
            width: max-content;
            max-width: unquote('min(520px, calc(100% - 120px))');
            background-color: #C4CF73;
            color: $success-text;
            box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.16);
        }
        .typed-element {
            width: auto;
            max-width: 100%;
            padding-right: 0;
        }
        .close {
            display: flex;
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            padding: 10px;
            justify-content: center;
            align-items: center;
            aspect-ratio: 1 / 1;
            border-radius: 4px;
            background-color: #89952C;
            background-size: 20px;
        }
    }
    &.progress {
        .andy-mood {
            background-image: img('alex_carita_07.svg');
        }
        .andy-talk {
            background-color: $progress-t30;
            color: $progress-s70;
        }
        .close {
            background-color: $progress-s20;
        }
    }
    &.warning {
        .andy-mood {
            background-image: img('alex_carita_05.svg');
        }
        .andy-talk {
            background-color: $warning-t30;
            color: $warning-s70;
        }
        .close {
            background-color: $warning-s20;
        }
    }
    &.error {
        .andy-mood {
            background-image: img('alex_carita_04.svg');
        }
        .andy-talk {
            background-color: #bd1f1e;
            color: $error-s70;
            span {
                color: $color-white;

                b {
                    color: inherit;
                }
            }
        }
        .close {
            background-color: #7a1313;
        }
    }
    &.login {
        .andy-mood {
        }
        .andy-talk {
        }
    }
    &.offline {
        .andy-mood {
            background-image: img('alex_carita_05.svg');
        }
        .andy-talk {
        }
    }
    &.important {
        .andy-mood {
        }
        .andy-talk {
        }
    }
    &.loading {
        .andy-mood {
        }
        .andy-talk {
        }
    }
}

.delete-timer-button {
    color: green;

    .button-undo {
        background-color: $color-white;
        width: 120px;
        height: 36px;
        border-radius: 4px;
        padding: 8px;
        font-family: $text-bold;
    }

    &.error {
        font-family: $text-bold !important;
        .andy-mood {
            background-image: img('alex_carita_04.svg');
        }
        .andy-talk {
            background-color: $color-error-500;
            color: $color-white;
            span {
                color: $color-white;
                font-family: $text-bold;
                b {
                    color: inherit;
                }
            }
        }
        .close {
            background-color: black;
        }
    }
}
// Coloca un piquito, como si fuera un dialogo (se necesita ponerle un border al padre)
// .andy-talk:after {
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 50%;
//     width: 0;
//     height: 0;
//     border: 6px solid transparent;
//     border-right-color: inherit;
//     border-left: 0;
//     // border-bottom: 0;
//     margin-top: -6px;
//     margin-left: -6px;
// }
</style>

// PORTRAIT STYLES
<style lang="scss">
.tooltip-container.portrait {
    z-index: 18000;
    bottom: 5px;
    padding: 0 5px;
    @include align-items(center);
    @include flex-wrap(nowrap);

    .andy-mood {
        position: relative;
        top: auto;
        left: auto;
        flex-shrink: 0;
    }

    .andy-talk {
        @include display-flex();
        @include align-items(center);
        @include flex-direction(row);
        @include font-size(s);
        flex: 1;
        width: auto;
        max-width: calc(100% - 76px);
        text-align: left;
        min-height: 55px;
        box-shadow: none;

        .typed-element {
            flex: 1;
            padding-right: 10px;
        }

        span {
            text-align: left;
            line-height: 16px;
            @include font-size(xs);
        }

        & b,
        & a {
            display: contents;
            font-family: $text-bold;
            @include font-size(xs);
        }

        & a {
            text-decoration: underline;
        }
    }

    &.success .andy-talk {
        flex: 0 1 auto;
        width: max-content;
        max-width: unquote('min(520px, calc(100% - 76px))');
    }
}

.app-safe-area {
    .tooltip-container.portrait {
        bottom: calc(env(safe-area-inset-bottom) + 10px);
    }
}

/* BUILD-7486: el $snackbar global se apila encima del banner persistente. */
body.has-timer-recommendation-banner {
    .tooltip-container:not(.recommendation) {
        bottom: calc(10px + var(--timer-recommendation-offset, 72px));
        z-index: $z-snackbar-default + 1;
    }

    .tooltip-container.portrait:not(.recommendation) {
        bottom: calc(5px + var(--timer-recommendation-offset, 72px));
        z-index: 18001;
    }
}

body.app-safe-area.has-timer-recommendation-banner {
    .tooltip-container.portrait:not(.recommendation) {
        bottom: calc(env(safe-area-inset-bottom) + 10px + var(--timer-recommendation-offset, 72px));
    }
}

.tooltip-container.recommendation {
    pointer-events: none;
    cursor: default;
    z-index: $z-snackbar-default;

    &.portrait {
        z-index: 17999;
    }

    .andy-mood {
        background-image: img('alex_carita_10.svg');
        pointer-events: none;
        cursor: default;
    }

    .andy-talk {
        background-color: $info-t30;
        color: $info-s70;
        max-width: calc(100% - 80px);
        width: auto;
        gap: 10px;
        pointer-events: auto;
        cursor: default;
    }

    .recommendation-info {
        flex-shrink: 0;
        color: $main;
        pointer-events: none;
    }

    .recommendation-message {
        flex: 1 1 auto;
        min-width: 0;
        text-align: left;
        font-family: $text;
        @include font-size(sm);
        pointer-events: none;

        b {
            font-family: $text-bold;
        }
    }

    .recommendation-actions {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: 8px;
        pointer-events: auto;
        position: relative;
        z-index: 1;
    }

    .recommendation-btn {
        margin: 0;
        padding: 8px 12px;
        border-radius: 4px;
        border: 1px solid transparent;
        font-family: $text-bold;
        font-size: 14px;
        line-height: 18px;
        white-space: nowrap;
        cursor: pointer;
        pointer-events: auto;

        &--ghost {
            background: $color-white;
            border-color: $neutro-dark;
            color: $main;
        }

        &--primary {
            background: $main;
            border-color: $main;
            color: $color-white;
        }
    }

    &.portrait {
        .andy-talk {
            flex-wrap: wrap;
            max-width: calc(100% - 12px);
        }

        .recommendation-message {
            flex: 1 1 calc(100% - 32px);
        }

        .recommendation-actions {
            width: 100%;
            justify-content: flex-end;
            flex-wrap: nowrap;
            gap: 8px;
            min-width: 0;
        }

        .recommendation-btn {
            flex: 1 1 auto;
            width: auto;
            max-width: 100%;
            min-width: 0;
            white-space: normal;
            text-align: center;
        }

        .recommendation-btn--primary {
            flex: 1 1 55%;
        }
    }
}

.tooltip-container.phu-waste-toast.error {
    .andy-mood {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        background-image: img('alex_carita_02_right.svg');
    }

    .andy-talk {
        gap: 24px;
        padding: 8px 16px;
        background-color: $error-light;
        color: $neutro-s80;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.04), 0 4px 4px rgba(0, 0, 0, 0.06);

        span {
            color: $neutro-s80;
            font-family: $text;
            letter-spacing: 0.25px;
            @include font-size(16px);

            b {
                color: $neutro-s80;
                font-family: $text-bold;
            }
        }
    }

    .button-undo {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        min-height: 28px;
        padding: 4px 8px;
        border-radius: 4px;
        background-color: $main-t90;
        color: $main;
        font-family: $text-bold;
        line-height: 18px;
        @include font-size(14px);
    }
}
</style>
